export default __webpack_public_path__ + "static/media/customersupport.12c39d90.svg";